import { CHANGE_USER_PHONE_REQUEST, CHANGE_USER_PHONE_SUCCESS, CHANGE_USER_PHONE_FAILURE } from '../../constants/user_phones.constants';

export const changeUserPhoneRequest = (name, phone, user_id, phone_id) => ({
    type: CHANGE_USER_PHONE_REQUEST, name, phone, user_id, phone_id,
});
export const changeUserPhoneRequestSuccess = payload => ({ type: CHANGE_USER_PHONE_SUCCESS, payload });
export const changeUserPhoneRequestFailure = error => ({ type: CHANGE_USER_PHONE_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_phones_actions/change_user_phone.actions.js